/* eslint-disable max-classes-per-file */

type PostMessage = (message: string, targetOrigin: string) => void;

export class ParentWindow {
  public postMessage: PostMessage = (message, targetOrigin) => {
    window.parent.postMessage(message, targetOrigin);
  };
}

export class StatefulParentWindow {
  private parentWindow: ParentWindow;

  constructor(embeddedIframe: ParentWindow) {
    this.parentWindow = embeddedIframe;
  }

  public postMessage: PostMessage = (message, targetOrigin) => {
    this.parentWindow.postMessage(message, targetOrigin);
  };
}

export const parentWindow = new StatefulParentWindow(new ParentWindow());
